
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export function About() {
  const { ref: leftRef, isVisible: leftVisible } = useScrollAnimation({ threshold: 0.1 });
  const { ref: rightRef, isVisible: rightVisible } = useScrollAnimation({ threshold: 0.1 });

  const features = [
    {
      icon: 'ri-time-line',
      title: 'Respuesta Rápida',
      description: 'Atención inmediata a tus consultas y problemas técnicos'
    },
    {
      icon: 'ri-team-line',
      title: 'Equipo Profesional',
      description: 'Técnicos certificados con amplia experiencia en el sector'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Garantía de Servicio',
      description: 'Respaldamos nuestro trabajo con garantía en todos los servicios'
    },
    {
      icon: 'ri-price-tag-3-line',
      title: 'Precios Competitivos',
      description: 'Tarifas justas y transparentes sin costos ocultos'
    }
  ];

  return (
    <section id="nosotros" className="py-20 bg-gray-900 relative overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom_right,rgba(0,255,240,0.06),transparent_60%)]"></div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div ref={leftRef} className={`anim-fade-left ${leftVisible ? 'visible' : ''}`}>
            <h2 className="text-3xl sm:text-4xl font-bold text-white mb-6">
              ¿Por qué elegirnos para tu <strong className="text-neon-400 text-neon-glow-sm">soporte técnico informático</strong>?
            </h2>
            <p className="text-base text-gray-400 mb-6 leading-relaxed">
              Somos una empresa especializada en <strong className="text-gray-200">servicios técnicos informáticos</strong> con años de experiencia brindando soluciones integrales a empresas y particulares en Capital Federal y Zona Norte del Gran Buenos Aires.
            </p>
            <p className="text-base text-gray-400 mb-8 leading-relaxed">
              Nuestro compromiso es ofrecer un <strong className="text-gray-200">servicio técnico IT</strong> de excelencia, combinando conocimiento técnico, atención personalizada y soluciones efectivas para mantener tu infraestructura tecnológica funcionando sin interrupciones.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {features.map((feature, index) => (
                <div
                  key={index}
                  className="flex items-start gap-4 group"
                  style={{
                    opacity: leftVisible ? 1 : 0,
                    transform: leftVisible ? 'translateY(0)' : 'translateY(20px)',
                    transition: `opacity 0.5s ease-out ${0.3 + index * 0.12}s, transform 0.5s ease-out ${0.3 + index * 0.12}s`,
                  }}
                >
                  <div className="w-12 h-12 flex items-center justify-center bg-neon-400/10 border border-neon-400/20 rounded-lg flex-shrink-0 group-hover:bg-neon-400/20 group-hover:scale-110 transition-all duration-300">
                    <i className={`${feature.icon} text-2xl text-neon-400`}></i>
                  </div>
                  <div>
                    <h3 className="text-base font-semibold text-white mb-1">
                      {feature.title}
                    </h3>
                    <p className="text-sm text-gray-400">
                      {feature.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div ref={rightRef} className={`relative anim-fade-right ${rightVisible ? 'visible' : ''}`}>
            <div className="relative rounded-2xl overflow-hidden shadow-neon border border-neon-400/20 hover-lift">
              <img 
                src="https://readdy.ai/api/search-image?query=professional%20IT%20technician%20working%20on%20computer%20hardware%20in%20dark%20modern%20tech%20lab%20with%20cyan%20neon%20ambient%20lighting%20server%20room%20background%20moody%20atmosphere%20high%20tech%20professional%20environment&width=600&height=500&seq=2&orientation=portrait"
                alt="Equipo de Soporte Técnico Informático profesional en Capital Federal"
                title="Soporte técnico informático profesional STI - Zona Norte y CABA"
                width="600"
                height="500"
                className="w-full h-[300px] sm:h-[500px] object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-gray-950/40 to-transparent"></div>
            </div>
            <div className="absolute -bottom-4 -right-4 w-48 h-48 bg-neon-400/10 border border-neon-400/20 rounded-2xl -z-10 neon-border-animate"></div>
            <div className="absolute -top-4 -left-4 w-48 h-48 bg-neon-400/5 border border-neon-400/10 rounded-2xl -z-10"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
